import {
  Button,
  Flex,
  SimpleGrid,
  Spinner,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { componentState } from "../../../../atoms/componentState";
import {
  VARIANT,
  WHITE,
  GREENMONEDD,
  REDMONEDD,
  GRAY_DARK,
  GRAY_NEUTRAL,
  BLUEMONEDDBUTTONS,
  BLUECARD,
  GRAYCARD,
  GREENCARD,
  REDCARD,
  ICECARD,
} from "../../../../constants/colors";
import {
  ExtractListCards,
  simplifiedExtract,
} from "../../../../interfaces/defaultInterfaces";
import ExtratoApi from "../../../../services/ExtratoAPI";

import { useSetRecoilState, useRecoilState } from "recoil";
import DateDropdown from "../../../../defaultComponents/dateDropdown";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../../vendas/listaDeVendas/SalesList";
import SalesListAPI from "../../../../services/SalesListApi";
import { toast } from "react-toastify";
import fileDownload from "js-file-download";
import CardExtract from "../defaultComponents/cardExtract";
import { LoggedUser } from "../../../../atoms/userLogged";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";

export default function SimplifiedDetails() {
  const navigate = useNavigate();

  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Extrato Simplificado");
  }, []);

  const dataInicio = moment(Date())
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date()).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
  const dataFuturo = moment("12/12/2077")
    .endOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");

  const [extractList, setExtractList] = useState(Array<simplifiedExtract>);
  const [cardExtract, setCardExtract] = useState<ExtractListCards>();
  const [currentPage, setCurrentPage] = useState(1);
  const [disable, setDisable] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const [pages, setPages] = useState(1);
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  const [loading, setLoading] = useState(false);

  const [saldo, setSaldo] = useState({
    saldoAnterior: 0,
    saldoPeriodo: 0,
  });
  const [saldoFuturo, setSaldoFuturo] = useState({
    saldoAnterior: 0,
    saldoPeriodo: 0,
  });
  const initialValues = {
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
  };
  const [filtros, setFiltros] = useState(initialValues);

  let dias =
    moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >=
    32;

  //função que receber os dados da lista de extrato
  async function getsaldoFuturo() {
    const dataFinalFunction = moment(filtros.finalDateFilter)
      .add(1, "day")
      .format("YYYY-MM-DDT00:00:00.000");
    try {
      setLoading(true);
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        dataFinalFunction,
        dataFuturo,
        id
      );
      setSaldoFuturo({
        ...saldo,
        saldoAnterior: response.data[0].saldoAnterior,
        saldoPeriodo: response.data[0].saldoPeriodo,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  async function getExtractDetails() {
    try {
      setLoading(true);
      const response = await ExtratoApi.getExtractPerClient(
        1,
        600,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setExtractList(response.data);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setLoading(false);
      // console.log("response", response.data);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  //função que preenche os cards com o saldo
  async function getSaldo() {
    try {
      setLoading(true);
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setSaldo({
        ...saldo,
        saldoAnterior: response.data[0].saldoAnterior,
        saldoPeriodo: response.data[0].saldoPeriodo,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  //função para pegar o nome do cliente
  async function getExtratcList() {
    try {
      setLoading(true);
      const response = await ExtratoApi.getExtractList(
        1,
        600,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id,
        ""
      );
      setCardExtract(response.data[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }

  useEffect(() => {
    getExtractDetails();
    getExtratcList();
    getsaldoFuturo();
    getSaldo();
  }, [filtros, pages, pageSize, currentPage]);

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getExtractDetails();
      getExtratcList();
    }
  }, [pages]);

  async function Export() {
    try {
      setDisable(true);
      const response = await SalesListAPI.exportDetailedExtract(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      fileDownload(response, "extrato.xlsx");
      setDisable(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  return (
    <Flex
      w={"100%"}
      h={"100%"}
      bgColor={"#F5F5F5"}
      // shadow={"xl"}
      flexDirection={"column"}
      // overflowY={"scroll"}
    >
      <Flex
        w={"100%"}
        h={"20%"}
        flexDirection={"column"}
        // pb={2}
        mb={8}
        // ml={4}
        // mx={2}
        justifyContent={"space-between"}
      >
        <SimpleGrid columns={8} spacingX={3} spacingY={2} w={"100%"} px={6}>
          <CardExtract
            value={saldo ? saldo.saldoAnterior : 0}
            bgColor={BLUECARD}
            color={"white"}
            description={`Saldo em : ${moment(filtros.initialDateFilter)
              .add(-1, "day")
              .format("DD/MM/YYYY")}`}
          />
          <CardExtract
            value={cardExtract ? cardExtract.vendaCartao : 0}
            bgColor={GRAYCARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Crédito"}
          />
          <CardExtract
            value={cardExtract ? cardExtract?.vendaCartaoDebito : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Débito"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.vendaBoleto : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Boletos"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.vendaPix : 0}
            bgColor={GRAYCARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas PIX"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoBoleto : 0} // novo
            bgColor={GRAYCARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Boleto`}
          />

          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoPIX : 0} // novo
            bgColor={GRAYCARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Pix`}
          />
          <CardExtract
            value={cardExtract ? cardExtract.lancamentoManualCredito : 0}
            bgColor={GREENCARD}
            color={"white"}
            description={"Lançamento de Crédito"}
          />

          <CardExtract
            value={cardExtract ? cardExtract.lancamentoManualDebito : 0}
            bgColor={REDCARD}
            color={"white"}
            description={"Lançamentos de Débito"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.pagamentoBoleto : 0}
            bgColor={GRAYCARD}
            color={BLUEMONEDDBUTTONS}
            description={"Pagamentos de Boleto"}
          />

          <CardExtract
            value={cardExtract ? cardExtract.transferenciaTED : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Transferências"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoVendaCartao : 0}
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={"Vendas Canceladas"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.disputaVendaCartao : 0}
            bgColor={GRAYCARD}
            color={BLUEMONEDDBUTTONS}
            description={"vendas em Disputa"}
          />
          <CardExtract
            value={cardExtract ? cardExtract.cancelamentoRemessaBoleto : 0} //novo
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Remessa Boleto`}
          />
          <CardExtract
            value={
              cardExtract ? cardExtract.cancelamentoRemessaTransferencia : 0
            } //novo
            bgColor={ICECARD}
            color={BLUEMONEDDBUTTONS}
            description={`Cancelamento Remessa Transferencia`}
          />
          <CardExtract
            value={saldo ? saldo.saldoAnterior + saldo.saldoPeriodo : 0}
            bgColor={BLUEMONEDDBUTTONS}
            color={"white"}
            description={`Saldo em: ${moment(filtros.finalDateFilter).format(
              "DD/MM/YYYY"
            )}`}
          />
        </SimpleGrid>
        {/* </Flex>
        </Flex> */}
      </Flex>
      <Flex
        w={"98%"}
        h={"8%"}
        py={7}
        px={"300px"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <DateDropdown filtros={filtros} setFiltros={setFiltros} />
        {/* <Button
          bgColor={BLUEMONEDDBUTTONS}
          color={WHITE}
          isDisabled={disable || dias}
          onClick={() => {
            Export();
          }}
        >
          {disable === true ? (
            <Spinner />
          ) : (
            <>
              <Icon mr={2} as={FaFileExport} />
              Exportar
            </>
          )}
        </Button> */}
        <Button
          bgColor={GRAY_NEUTRAL}
          color={WHITE}
          onClick={() => {
            setFiltros(initialValues);
          }}
        >
          Limpar Filtros
        </Button>
      </Flex>
      {loading ? (
        <Flex
          w={"100%"}
          h={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          px={2}
          flexDirection="column"
        >
          <Spinner size={"lg"} color={VARIANT} />
        </Flex>
      ) : (
        <Flex
          w={"100%"}
          h={"45vh"}
          alignItems={"flex-start"}
          px={2}
          flexDirection="column"
          overflowY={"scroll"}
        >
          <Table variant={"striped"} fontSize={"0.8rem"}>
            <Thead
              h="50px"
              position="sticky"
              top="0"
              bgColor={BLUEMONEDDBUTTONS}
            >
              <Tr>
                <Th
                  // w={"300px"}
                  fontWeight={"bold"}
                  borderRadius={"8px 0 0 8px"}
                  // textAlign={"center"}
                  bgColor={"none"}
                  // color={BLUEMONEDDBUTTONS}
                  color={"white"}
                  fontSize={"11px"}
                  w={"9vw"}
                >
                  Data de Lançamento
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"10vw"}>
                  Tipo de Lançamento
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"16vw"}>
                  Id da Venda
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"8vw"}>
                  Data de Venda
                </Th>
                {/* <Th color={"white"} fontSize={"11px"} w={"8vw"}>
                  Status
                </Th> */}
                <Th color={"white"} fontSize={"11px"} w={"10vw"}>
                  Pagador
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"6vw"}>
                  Nro da Parcela
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"6vw"}>
                  valor Bruto
                </Th>
                <Th color={"white"} fontSize={"11px"} w={"6vw"}>
                  Taxa Cliente
                </Th>
                {/* <Th color={"white"}>Tipo de Venda</Th> */}
                <Th color={"white"} fontSize={"11px"} w={"6vw"}>
                  Valor
                </Th>

                <Th
                  color={"white"}
                  borderRadius={"0 8px 8px 0"}
                  fontSize={"11px"}
                  w={"7vw"}
                >
                  Saldo
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {extractList &&
                extractList.map((item, index) => {
                  // console.log("item", item);
                  return (
                    <Tr key={index}>
                      <Td
                        borderRadius={"8px 0px 0px 8px"}
                        fontSize="12px"
                        w={"10vw"}
                      >
                        {moment(item?.dataLancamento).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </Td>
                      <Td fontSize="12px" w={"8vw"}>
                        {item?.tipoLancamento?.lancamento
                          ? item?.tipoLancamento?.lancamento
                          : null}
                      </Td>
                      <Td fontSize="12px" w={"10vw"}>
                        {item.transacao?.idTransacao &&
                          item.transacao?.idTransacao}
                      </Td>
                      <Td fontSize="12px" w={"12vw"}>
                        {item.transacao?.dataCriacao &&
                          moment(item.transacao?.dataCriacao).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                      </Td>
                      {/* <Td fontSize="12px" w={"8vw"}>
                        {item.transacao?.statusVenda?.status
                          ? item.transacao?.statusVenda?.status
                          : item.transacao?.status
                          ? item.transacao?.status
                          : ""}
                      </Td> */}
                      <Td fontSize="12px" w={"10vw"}>
                        {item.transacao?.clienteNome &&
                          item.transacao?.clienteNome}
                      </Td>
                      <Td fontSize="12px">
                        {item.parcela
                          ? `${item.parcela}/${item.nroParcelas}`
                          : ``}
                      </Td>
                      <Td fontSize="12px" w={"6vw"}>
                        {item?.transacao &&
                          item?.transacao?.valor.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </Td>
                      <Td color={REDMONEDD} fontSize="12px" w={"6vw"}>
                        {item?.transacao &&
                          item?.transacao?.taxaCliente.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </Td>
                      {/* <Td>
                      {item.transacao?.produto.nome &&
                        item.transacao?.produto.nome}
                    </Td> */}
                      {(item?.tipoLancamento?.sinal === "C" && (
                        <Td color={GREENMONEDD} fontSize="12px" w={"6vw"}>
                          {" "}
                          {item?.valor.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                      )) ||
                        (item?.tipoLancamento?.sinal === "D" && (
                          <Td color={REDMONEDD} fontSize="12px" w={"6vw"}>
                            {" "}
                            {item?.valor.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </Td>
                        )) ||
                        (item?.tipoLancamento?.sinal === "X" && (
                          <Td color={GRAY_DARK} fontSize="12px" w={"6vw"}>
                            {"-- --"}
                          </Td>
                        )) ||
                        null}
                      <Td
                        borderRadius={"0 8px 8px 0"}
                        fontSize="12px"
                        w={"6vw"}
                      >
                        {item?.saldo === 0
                          ? "R$ 0,00"
                          : item?.saldo?.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </Flex>
      )}
    </Flex>
  );
}
